import { useMemo } from 'react';

import { Dimensions } from 'components/insights/constants';
import { getInboundSlideoutEntityFilter, useInboundReferralsInsightsStore } from 'stores/inboundReferralsInsightsStore';

import { getInboundEntitySlideoutParams, withInboundDimensionIds } from '../constants';
import useInboundReferralAnalytics from '../query/useInboundReferralAnalytics';

// Runs the active View-By query for the open slideout, scoped to the clicked entity (via
// extraFilters). One rollups query feeds both the breakdown table (grouping-0 rows) and the header
// tiles (the fully-rolled-up `overall` row) — the inbound source needs no per-tile fan-out.
export default function useInboundSlideoutAnalytics() {
  const slideoutContext = useInboundReferralsInsightsStore((state) => state.slideoutContext);
  const slideoutDimension = useInboundReferralsInsightsStore((state) => state.slideoutDimension);

  const extraFilters = useMemo(
    () => (slideoutContext ? getInboundSlideoutEntityFilter(slideoutContext) : null),
    [slideoutContext]
  );

  // Fall back to a valid dimension so the hook always has params; the query is gated by `enabled`.
  const params = useMemo(
    () => withInboundDimensionIds(getInboundEntitySlideoutParams(slideoutDimension ?? Dimensions.FACILITY)),
    [slideoutDimension]
  );

  const enabled = !!slideoutContext && !!slideoutDimension;

  const { data, rollups, loading } = useInboundReferralAnalytics(params, {
    enabled,
    extraFilters,
    queryKey: `inbound-slideout-view-by:${slideoutDimension ?? 'none'}`,
  });

  return { data, rollups, loading: enabled && loading, extraFilters };
}
